// extracted by mini-css-extract-plugin
export default {"body":"PanelStack-module__body___VSf+b","panel":"PanelStack-module__panel___1EEK-"};